export default "__VITE_ASSET__CkaiDH0u__"